import { useRailbar } from "@circle-react/hooks/chatsV2/useRailbar";
import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";
import { useCallback } from "react";

import { useProfileDrawer } from "@/react/components/Drawers/ProfileDrawer";

/**
 * Opens a member profile in the railbar, the way direct messages already show
 * the other participant. The profile modal stays in place on mobile and on
 * surfaces without a railbar of their own (live streams, course comments,
 * search results, drawers).
 */
export const useOpenMemberProfile = () => {
  const memberProfileDrawer = useProfileDrawer();
  const isMobile = useIsMobile();
  const {
    canOpenMemberProfileRailbar,
    isLiveStream,
    openMemberProfileRailbar,
  } = useRailbar();

  const shouldUseRailbar = canOpenMemberProfileRailbar && !isMobile;

  return useCallback(
    (memberPublicId: string) => {
      if (!memberPublicId) return;

      if (shouldUseRailbar) {
        openMemberProfileRailbar(memberPublicId);
        return;
      }

      void memberProfileDrawer.show({
        memberPublicId,
        params: {
          shouldOpenInNewTab: isLiveStream,
        },
      });
    },
    [
      isLiveStream,
      memberProfileDrawer,
      openMemberProfileRailbar,
      shouldUseRailbar,
    ],
  );
};
